import { MailOutlined } from "@ant-design/icons";
import { Flex, Result, Typography } from "antd";
import React from "react";
import { Organization } from "../../Interface/Index";

interface OrgPlanExpiredProps {
  organization: Organization;
}

const OrgPlanExpired: React.FC<OrgPlanExpiredProps> = ({ organization }) => {
  return (
    <div className="message-section">
      <Flex align="center" justify="center" vertical gap={16}>
        <Result
          status="warning"
          title={`Thank you for your interest
          ${organization ? " in " + organization?.orgName : ""}`}
          subTitle="Currently, we are not accepting any applications at the moment. We will notify you when opportunities become available."
           style={{maxWidth: 800}}
        />
      </Flex>
    </div>
  );
};

export default OrgPlanExpired;
